// src/utils/workoutDetailsUtils.js
export const convertSecondsToTimeStr = (seconds) => {
  if (seconds === 0) return "N/A";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs < 10 ? "0" : ""}${secs} min`;
};

export const parseReps = (repsWithType) => {
  const repsType = repsWithType.charAt(0);
  const repsValueRaw = repsWithType.slice(1);
  if (repsType === "C") {
    return repsValueRaw.includes("-") ? repsValueRaw : parseInt(repsValueRaw, 10) || "N/A";
  } else if (repsType === "T") {
    const timeInSeconds = parseInt(repsValueRaw, 10) || 0;
    return convertSecondsToTimeStr(timeInSeconds);
  }
  return "N/A";
};

export const parseExerciseData = (dataString) => {
  return dataString.split("|").map((exerciseStr) => {
    const [exercise_id, sets, repsWithType, restInSeconds] = exerciseStr.split(",");
    return {
      exercise_id: parseInt(exercise_id, 10),
      sets: parseInt(sets, 10) || 0,
      reps: parseReps(repsWithType),
      rest: convertSecondsToTimeStr(parseInt(restInSeconds, 10) || 0),
      rest_seconds: parseInt(restInSeconds, 10) || 60,
    };
  });
};
